import mixpanel from "mixpanel-browser";

mixpanel.init("95685dd2341064c36a6485d35dc52c86", {
  //debug: true,
  ignore_dnt: true,
});
//mixpanel.init("YOUR_MIXPANEL_TOKEN");

let env_check = process.env.NODE_ENV === "production";

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;
